import { createRouter, createWebHistory } from 'vue-router'

export const router = createRouter({
  linkActiveClass: 'is-active',
  linkExactActiveClass: 'is-exact-active',
  history: createWebHistory(),
  // base: window.inside.baseUrl,
  routes: [],
})
